/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Organism1 from "../../organisms/organism-1/index";
import Headline from "../../atoms/headline";
import ReadMore from "../../atoms/read-more";
import DfpAd from "../../dfp-ad";

import "./twelve-stories-two-images.m.css";

import { getSlug } from "../../utils";

class TwelveStoriesTwoImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collectionIndex: 0
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { collection, sections } = this.props;
    const collectionItems = collection.items ? collection.items : [];
    const collections = collectionItems.filter(item => item.type === "collection" && item.items.length > 2).slice(0, 2);

    const generateRowDom = collections.map((item, index) => {
      const slug = getSlug(item, sections);

      return (
        <div key={index}>
          {this.state.width > 767 && (
            <div styleName="title-container">
              <Link styleName="link" href={slug}>
                <Headline text={item.name} headerType={3} headerLevel={3} />
              </Link>
              {item.items.length > 6 && (
                <Link className="read-more" href={slug}>
                  <span styleName="content">See More Stories</span>
                </Link>
              )}
            </div>
          )}
          {this.state.width < 768 &&
            this.state.collectionIndex === index && <Organism1 collection={item} headlineLimit={70} widths={[250]} />}
          {this.state.width > 767 && <Organism1 collection={item} headlineLimit={70} />}
          {this.state.width < 768 &&
            item.items.length > 6 &&
            this.state.collectionIndex === index && <ReadMore href={slug} />}
        </div>
      );
    });

    const collectionsHeader = collections.map((item, index) => {
      const customHeaderType = this.state.collectionIndex === index ? 2 : 4;
      const activeTab = this.state.collectionIndex === index ? "active" : "inactive";

      return (
        <Headline
          active={activeTab}
          text={item.name}
          headerType={customHeaderType}
          headerLevel={3}
          onClick={() => this.setState({ collectionIndex: index })}
          key={index}
        />
      );
    });

    return collections.length > 1 ? (
      <div styleName="wrapper">
        <div styleName="content-wrapper">
          <div styleName="header-tabs">{collectionsHeader}</div>
          {generateRowDom}
        </div>
        <div styleName="dfp-ad-728x90">
          <DfpAd adtype="leaderboard_4_728x90" />
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(TwelveStoriesTwoImages);

TwelveStoriesTwoImages.propTypes = {
  collection: object,
  sections: array
};
